import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { useQuery } from '@tanstack/react-query';
import { DateRange } from 'react-day-picker';
import { format } from 'date-fns';
import { getTrackingData } from '@/services/trackingService';
import { useAuth } from '@/hooks/useAuth';

export function useTrackingData(dateRange?: DateRange) {
  useLanguage();
  const { token, isAuthenticated } = useAuth();

  const startDate = dateRange?.from ? format(dateRange.from, 'yyyy-MM-dd') : undefined;
  const endDate = dateRange?.to ? format(dateRange.to, 'yyyy-MM-dd') : undefined;

  return useQuery({
    queryKey: ['tracking-data', token, startDate, endDate], // Inclui token e período para invalidar quando mudarem
    queryFn: () => {
      if (!token) {
        throw new Error(translateInterfaceText("Token não disponível"));
      }
      return getTrackingData(token, startDate, endDate);
    },
    enabled: !!token && isAuthenticated,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: 2,
    refetchOnMount: true, // Refetch ao montar para garantir dados atualizados
  });
}
